import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

// Car-shaped heart/favorite icon
export const CarHeartIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M3 8h2l1-2h12l1 2h2a1 1 0 011 1v8a2 2 0 01-2 2H4a2 2 0 01-2-2V9a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="6.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="17.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M12 7c-1.5-2-4-2-4 0s4 4 4 4 4-2 4-4-2.5-2-4 0z" fill="currentColor" opacity="0.3" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

// Car-shaped cart icon
export const CarCartIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M2 3h3l1.5 1h11l1.5-1h3a1 1 0 011 1v2l-2 9H4L2 6V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    <circle cx="7" cy="19" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="17" cy="19" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M4 5h16" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
    <circle cx="12" cy="11" r="3" stroke="currentColor" strokeWidth="1" opacity="0.3"/>
    <text x="12" y="12.5" textAnchor="middle" fontSize="4" fill="currentColor" fontWeight="bold">TX</text>
  </svg>
);

// Car-shaped search icon
export const CarSearchIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="11" cy="10" r="5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M15 14l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3 16h2l1-1h12l1 1h2" stroke="currentColor" strokeWidth="1" opacity="0.3"/>
    <circle cx="5.5" cy="18" r="1.2" stroke="currentColor" strokeWidth="1" opacity="0.3"/>
    <circle cx="18.5" cy="18" r="1.2" stroke="currentColor" strokeWidth="1" opacity="0.3"/>
  </svg>
);

// Car-shaped shipping/delivery icon
export const CarShippingIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M1 6h14v10H1z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M15 9h4l3 4v3h-7V9z" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="5.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="18.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M7.5 18v-3h6v3" stroke="currentColor" strokeWidth="1" opacity="0.3"/>
  </svg>
);

// Car-shaped menu/hamburger icon
export const CarMenuIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M3 8h2l1-2h12l1 2h2a1 1 0 011 1v8a2 2 0 01-2 2H4a2 2 0 01-2-2V9a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="6.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="17.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="7" y1="11" x2="17" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="7" y1="14" x2="17" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Category icons
export const SprayIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="8" y="8" width="8" height="14" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 8V5a2 2 0 012-2h0a2 2 0 012 2v3" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M16 5l2-2m0 0l2 2m-2-2v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="10" y1="12" x2="14" y2="12" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
  </svg>
);

export const CleaningIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M4 20h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 20V8l4-4 4 4v12" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="13" r="3" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
    <path d="M12 10v6" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
    <path d="M9 13h6" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
  </svg>
);

export const PerfumeIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="7" y="10" width="10" height="12" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 10V7h4v3" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M9 7h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="12" cy="4" r="1.5" fill="currentColor" opacity="0.3"/>
    <path d="M12 5.5v-1" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
    <circle cx="9" cy="3" r="0.8" fill="currentColor" opacity="0.2"/>
    <circle cx="15" cy="3" r="0.8" fill="currentColor" opacity="0.2"/>
  </svg>
);

export const WaterIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12 2C12 2 5 10 5 15a7 7 0 0014 0c0-5-7-13-7-13z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M9 15a3 3 0 003 3" stroke="currentColor" strokeWidth="1" opacity="0.5" strokeLinecap="round"/>
  </svg>
);

export const WinterIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12 2v20M2 12h20M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1" opacity="0.3"/>
    <circle cx="12" cy="2" r="1.5" fill="currentColor" opacity="0.5"/>
    <circle cx="12" cy="22" r="1.5" fill="currentColor" opacity="0.5"/>
    <circle cx="2" cy="12" r="1.5" fill="currentColor" opacity="0.5"/>
    <circle cx="22" cy="12" r="1.5" fill="currentColor" opacity="0.5"/>
  </svg>
);

export const AntifreezeIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M8 4h8l2 16H6L8 4z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M8 4h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 9v6M14 9v6M12 7v10" stroke="currentColor" strokeWidth="1" opacity="0.5" strokeLinecap="round"/>
    <circle cx="12" cy="20" r="1" fill="currentColor" opacity="0.3"/>
  </svg>
);

export const CarMaintenanceIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M3 8h2l1-2h12l1 2h2a1 1 0 011 1v8a2 2 0 01-2 2H4a2 2 0 01-2-2V9a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="6.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="17.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 11l2 2 2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 13v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const ProfessionalIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="6" y="4" width="12" height="18" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 4V2h4v2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M6 8h12" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
    <text x="12" y="16" textAnchor="middle" fontSize="6" fill="currentColor" fontWeight="bold">PRO</text>
  </svg>
);

export const CustomSetIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="13" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="3" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M17 13v8M13 17h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const categoryIconMap: Record<string, React.FC<IconProps>> = {
  spray: SprayIcon,
  cleaning: CleaningIcon,
  perfume: PerfumeIcon,
  water: WaterIcon,
  winter: WinterIcon,
  antifreeze: AntifreezeIcon,
  carmaintenance: CarMaintenanceIcon,
  professional: ProfessionalIcon,
  customset: CustomSetIcon,
};
